import { useState, useEffect } from 'react';
import { Table, Button, Tag, message, Popconfirm, Modal, Rate } from 'antd';
import { DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import API from '../api/client';

const typeLabels = { oneri: 'Öneri', memnuniyet: 'Memnuniyet', sikayet: 'Şikayet', diger: 'Diğer' };
const typeColors = { oneri: 'blue', memnuniyet: 'green', sikayet: 'red', diger: 'default' };

const FeedbacksPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [detail, setDetail] = useState(null);

  const load = async () => {
    try {
      const res = await API.get('/feedbacks');
      setData(res.data);
    } catch { message.error('Veriler yüklenemedi'); }
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await API.put(`/feedbacks/${id}/read`);
    load();
  };

  const handleDelete = async (id) => {
    await API.delete(`/feedbacks/${id}`);
    message.success('Silindi');
    load();
  };

  const openDetail = (record) => {
    setDetail(record);
    if (!record.read) markRead(record._id);
  };

  const columns = [
    {
      title: 'Ad Soyad', dataIndex: 'name', key: 'name',
      render: (text, r) => <span style={{ fontWeight: r.read ? 400 : 700 }}>{text}</span>,
    },
    {
      title: 'Tür', dataIndex: 'type', key: 'type',
      render: (t) => <Tag color={typeColors[t]}>{typeLabels[t] || t}</Tag>,
    },
    {
      title: 'Puan', dataIndex: 'rating', key: 'rating',
      render: (r) => r ? <Rate disabled defaultValue={r} style={{ fontSize: 14 }} /> : '-',
    },
    { title: 'İşletme', dataIndex: 'businessName', key: 'biz', render: (t) => t || '-' },
    {
      title: 'Durum', dataIndex: 'read', key: 'read',
      render: (read) => read ? <Tag>Okundu</Tag> : <Tag color="red">Yeni</Tag>,
    },
    {
      title: 'Tarih', dataIndex: 'createdAt', key: 'date',
      render: (d) => d ? new Date(d).toLocaleDateString('tr-TR') : '-',
    },
    {
      title: 'İşlem', key: 'action',
      render: (_, record) => (
        <div style={{ display: 'flex', gap: 8 }}>
          <Button size="small" icon={<EyeOutlined />} onClick={() => openDetail(record)}>Detay</Button>
          <Popconfirm title="Silmek istediğinize emin misiniz?" onConfirm={() => handleDelete(record._id)}>
            <Button size="small" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <>
      <h2 style={{ marginBottom: 20 }}>Görüşler & Geri Bildirimler</h2>
      <Table columns={columns} dataSource={data} rowKey="_id" loading={loading} scroll={{ x: 800 }} />

      <Modal
        title="Görüş Detayı"
        open={!!detail}
        onCancel={() => setDetail(null)}
        footer={null}
        width={550}
      >
        {detail && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Tag color={typeColors[detail.type]} style={{ fontSize: 14, padding: '4px 12px' }}>
                {typeLabels[detail.type] || detail.type}
              </Tag>
              {detail.rating > 0 && <Rate disabled defaultValue={detail.rating} />}
            </div>
            <div><strong>Ad Soyad:</strong> {detail.name}</div>
            {detail.businessName && <div><strong>İşletme:</strong> {detail.businessName}</div>}
            {detail.phone && <div><strong>Telefon:</strong> {detail.phone}</div>}
            {detail.email && <div><strong>E-posta:</strong> {detail.email}</div>}
            <div style={{ background: '#fafafa', padding: 16, borderRadius: 10, fontSize: 14, lineHeight: 1.7 }}>
              {detail.message}
            </div>
            <div style={{ fontSize: 12, color: '#999' }}>
              {detail.createdAt ? new Date(detail.createdAt).toLocaleString('tr-TR') : '-'}
            </div>
          </div>
        )}
      </Modal>
    </>
  );
};

export default FeedbacksPage;
